import { Box } from '@mui/material';
import { useAtom, useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import ViewSwitch, { viewSwitchButtonClass } from '../common/components/ViewSwitch';
import {
  wishlistActiveTabAtom,
  wishlistItemsAtom,
  WishlistTab,
  wishlistSupplierAtom,
} from './state';

export default function WishlistTabs(): React.JSX.Element {
  const { t } = useTranslation(['wishlist']);
  const [activeTab, setActiveTab] = useAtom(wishlistActiveTabAtom);
  const wishlistItems = useAtomValue(wishlistItemsAtom);
  const wishlistSuppliers = useAtomValue(wishlistSupplierAtom);

  return (
    <Box
      sx={{
        [`& .${viewSwitchButtonClass}`]: {
          width: 144,
        },
      }}
    >
      <ViewSwitch
        value={activeTab}
        firstViewValue="product"
        secondViewValue="supplier"
        firstViewValueLabel={t('wishlist:tab_products', { count: wishlistItems.length })}
        secondViewValueLabel={t('wishlist:tab_suppliers', { count: wishlistSuppliers.length })}
        onChange={(value: string) => setActiveTab(value as WishlistTab)}
      />
    </Box>
  );
}
